
<template>
  <div>
    <v-dialog
      v-model="dialog" 
      max-width="800px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize">
            {{ $tc('templates.new')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="templateForm">
            <v-text-field
              :placeholder="$t('templates.name_form_label')"
              solo flat class="black--text" style="font-weight: 900; font-size: large !important;"
              v-model="new_template.name" dense
              :rules="required"
            ></v-text-field>

            <v-row align="center" class="pa-3" >
              <b class="subtitle-1 black--text mb-7 mr-2"> {{ $t('projects.kind') }} </b>
              <v-col cols="7" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="new_template.kind"
                  :rules="required"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3" >
              <b class="subtitle-1 black--text mb-0 mr-2"> {{ $t('color') }}: </b>
              <v-col cols="8" class="pa-0">
                <v-menu offset-x width="300px" :close-on-content-click="false" rounded="lg" open-on-hover>
                  <template v-slot:activator="{on}">
                    <v-chip pill v-on="on">
                      <v-avatar :color="new_template.color" left ></v-avatar>
                      {{ new_template.color }}
                    </v-chip>
                  </template>
                  <v-card width="330px">
                    <v-card-text>
                      <v-color-picker 
                        v-model="color"
                        dot-size="25"
                        hide-sliders
                        hide-mode-switch
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                        :value="the_color"
                      ></v-color-picker>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>

            

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-0 mr-2"> {{ $t('projects.stages_from') }}: </b>
              <v-btn color="accent" small class="black--text elevation-0 text-capitalize" rounded @click="addStage()">
                <v-icon left small >mdi-plus</v-icon>
                {{ $t('stages.add_new') }}
              </v-btn>
            </v-row>


            <!-- <v-row align="center" class="pa-3"> -->
              <draggable v-model="stages" v-bind="dragOptions" @change="reorder" @start="handleDragStart" @end="handleDragStop" draggable=".bacon" handle=".handle">
            <transition-group type="transition" :name="!is_dragging ? 'flip-list' : null">
              <v-col class="pa-0 mb-2 bacon" cols="12" v-for="(stage, idx) in stages" :key="stage.ref">
                <v-row align="center" class="pa-3">
                  <v-col cols="11" class="pa-0" align='right'>
                    <base-info-card with_spacer @click="openStage(stage, idx)">
                      <template slot="icon">
                        <v-icon ref="icon_draggable" class="handle" :style="{cursor: is_dragging? 'grabbing':'grab'}">mdi-drag</v-icon>
                        <span :class="['mr-3', any_stage_with_same_positions && stages_with_same_positions[stage.position] > 1? 'red--text' : null]">
                          # {{ stage.position }}
                        </span>
                      </template>
                      <template slot="text">
                        <span style="max-width: 35vw;" class="black--text title text-truncate"> 
                          {{ stage.name }}
                        </span>
                      </template>
                      <template slot="last">
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-chip  class="my-1 my-sm-0 mr-2" v-on="on">
                              <v-avatar left>
                                <v-icon>mdi-tune</v-icon>
                              </v-avatar>
                              {{ stage.qtd_alterations }}
                            </v-chip>
                          </template>
                          {{ $t('stages.alterations') }}
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-chip  class="my-1 my-sm-0" v-on="on">
                              <v-avatar left>
                                <v-icon>mdi-calendar</v-icon>
                              </v-avatar>
                              {{ stage.default_duration_days }} {{$tc('day', 2).toLowerCase()}}
                            </v-chip>
                          </template>
                          {{ $t('stages.expected_duration') }}
                        </v-tooltip>
                      </template>
                    </base-info-card>
                  </v-col>
                  <v-btn icon color="error" @click="removeStage(idx)"><v-icon>mdi-delete</v-icon></v-btn>
                </v-row>
              </v-col>
            </transition-group>
              </draggable>
            <!-- </v-row> -->

          </v-form>
        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelTemplate" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveTemplate" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>

    <dialog-new-stage v-if="new_stage" :max_positions="stages.length + 1" :position="position" :one_stage="one_stage" @done="handleDoneStage" @cancel="handleCancelStage"></dialog-new-stage>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import draggable_helpers from '@/mixins/draggable_helpers'
import Api from '@/api/index';
import DialogNewStage from './control/DialogNewStage.vue';

export default {
  name: 'DialogCreateTemplate',
  mixins: [ validations, draggable_helpers ],
  components: {
    DialogNewStage
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      new_template: {
        name: null,
        color: null,
        user_ids: [],
        // qtd_responsibles: 1,
        expected_conclusion_at: null, // this.$dayjs().format('YYYY-MM-DD')
        stages_attributes: [],
        use_type: 'template',
      },
      stages: [],
      default_one_stage: {
        status: 'not_started',
        name: null,
        kind: null,
        use_type: 'template',
        default_duration_days: 10,
        started_at: null,
        expected_conclusion_at: null,
        json_attributes: {},
          // subtasks: [],
          description: null,
          qtd_alterations: 0,
      },
      // default_sub_task: {
      //   name: null,
      //   status: 'open',
      //   due_at: null,
      //   done_at: null, 
      // },

      the_color: this.genRndColor(),

      employees: [],
      loading_employees: false,
      search_employee: null,

      new_stage: false,
      one_stage: null,
      position: 0,

      loading: false,
    }
  },
  methods: {
    reorder(){
      this.stages = this.stages.map((t, idx)=> {return {...t, position: idx + 1}})
    },
    genRndColor(){
      const hex = [...Array(8)].map(() => Math.floor(Math.random() * 16).toString(16)).join('').toUpperCase();
      return `#${hex}`
    },
    async getEmployees(id = null, query = null){
      Api.Employee.index({user_name: query}).then(r => r.data).then(d => {
        d = d.data? d.data.map(o => o.attributes) : d
        d = [d].flat()
        this.items = [...d];
      }).catch(err => {
        console.log(err);
      }).finally(() => (this.loading_employees = false));
    },
    addStage(){
      this.new_stage = true
      this.position = this.stages.length + 1
    },
    openStage(stage, idx){
      this.one_stage = {...stage, idx}
      this.position = this.one_stage.position
      this.new_stage = true 
    },
    removeStage(idx){
      this.stages.splice(idx, 1)
      this.reorder()
    },
    handleDoneStage(e){
      const {idx, ...stage} = e
      if (idx > -1){
        this.stages.splice(idx, 1, {...stage, ref: Math.random()})
      } else {
        this.stages.push({...stage, ref: Math.random()})
      }
      this.stages = this.stages.sort((a,b) => Number(a.position) - Number(b.position)); // b - a for reverse sort)
      this.handleCancelStage()
    },
    handleCancelStage(){
      this.new_stage = false 
      this.one_stage = null
    },
    cancelTemplate(){
      this.dialog = false
    },
    saveTemplate(){
      if (this.$refs.templateForm.validate() && this.stages.length && !this.any_stage_with_same_positions){
        this.submitTemplate()
      } else if (this.any_stage_with_same_positions){
        const msg = {
          type: 'error',
          msg: this.$t('templates.validations.stages_with_same_postions')
        }
        this.addNotification(msg)
      } else if (!this.stages.length){
        const msg = {
          type: 'error',
          msg: this.$t('templates.validations.no_stages')
        }
        this.addNotification(msg)
      }
    },
    submitTemplate(){
      this.loading = true
      let obj = {
        ...this.new_template,
        stages_attributes: [...this.stages]
      }
      Api.Project.create(obj).then(() => {
        this.$router.go(-1)
      }).catch(err=> {
        console.log({err});
      }).finally(()=> this.loading = false)
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    color: {
      get () {
        return this.the_color
      },
      set (v) {
        this.the_color = v
        this.new_template.color = v
      },
    },

    any_stage_with_same_positions(){
      if (this.stages.length){
        let positions = this.stages.map(({position})=> Number(position))
        positions = positions.sort()
        const pos = [...new Set(positions)]
        if (pos.length < positions.length){
          return true
        } else {
          return false
        }
      }
    },
    stages_with_same_positions(){
      if (this.any_stage_with_same_positions){
        let positions = this.stages.map(({position})=> Number(position))
        positions = positions.sort()
        let obj = {}
        positions.forEach(pos => {
          if (obj[pos]){
            obj[pos] += 1
          } else {
            obj[pos] = 1
          }
        });
        return obj
      } 
      return null
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.new_template.color = this.the_color
  },
  watch: {
    the_color(nv,ov) {
      if (nv){
        this.new_template.color = nv
      } else if (nv == false){
    
      }
    },
    dialog(nv, ov) {
      if (nv == false){
        this.$router.go(-1)
      }
    },
    search_employee(val) {
      if (val && val.length >= 3 && !this.loading_employees){
        this.loading_employees = true;
  
        // Lazily load input items

        if (navigator.onLine){
          this.getEmployees(null, val)
        } 
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep.rounder.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    border: solid 1px #a5a5a5;
  }

</style>